export default __webpack_public_path__ + "static/media/searchicondark.a2e586b4.svg";